import { render, staticRenderFns } from "./CreateQuestionCategoryModal.vue?vue&type=template&id=15378d38&scoped=true&"
import script from "./CreateQuestionCategoryModal.vue?vue&type=script&lang=js&"
export * from "./CreateQuestionCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15378d38",
  null
  
)

export default component.exports